import { TimesheetExpenseInterface } from '../../../interfaces/timesheet.interface';

export class PickTimesheetExpense {
    public static readonly type = '[JobsPlacements] Pick a timesheet expense';

    constructor(public timesheetExpense: TimesheetExpenseInterface | null) { }
}
